import { useCallback } from 'react';
import { useForm } from 'react-final-form';

export const useUpdateFieldValue = ({ fieldName }: { fieldName: string }) => {
    const {
        change,
        focus,
        blur
    } = useForm();

    return useCallback((value: string): void => {
        change(fieldName, value);
        focus(fieldName);
        blur(fieldName);
    }, [
        blur,
        focus,
        change,
        fieldName
    ]);
};
